export const styles = () => ({
  loadContainer: {
    position: 'relative',
    minHeight: 200,
  },
  divider: {
    marginTop: 20,
  },
});
